@reference "@glow/tailwind-config/reference.css";

.text {
  @apply text-emphasis-high;
  @apply font-semibold;
  @apply text-xl;
  @apply flex;
  @apply items-center;
  @apply gap-2;
}

.h4 {
  @apply m-0;
  @apply flex;
  @apply gap-4;
  @apply items-center;
}

.link {
  @apply text-base;
  @apply text-primary-500;
}
